import { useQuery } from "@tanstack/react-query";

import { QueryKey } from "@/constants/shared";
import { makeRequest } from "@/network/api";
import { CampaignData } from "@/types";

export const useGuardiansCampaignStats = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.GuardiansOfPlumeStats],
    queryFn: async (): Promise<CampaignData> => {
      const campaignStatsRes = await makeRequest(
        "/campaigns/protectors-of-plume/stats",
      );
      const campaignResJson: { data: CampaignData } =
        await campaignStatsRes.json();
      campaignResJson?.data?.top100Users.sort((a, b) => a.rank - b.rank);
      return campaignResJson?.data ?? {};
    },
  });
  const { campaign } = data ?? {};

  const { endDate } = campaign ?? {};
  const campaignEndDate = endDate ? new Date(endDate) : undefined;
  const campaignComplete = Boolean(
    campaignEndDate && new Date() > campaignEndDate,
  );
  return {
    guardiansCampaignStats: data
      ? {
          ...data,
          campaignComplete,
          campaignEndDate,
        }
      : undefined,
    guardiansCampaignPending: isPending,
    guardiansCampaignError: error,
    guardiansCampaignIsError: isError,
  };
};
